import { FC } from "react";
import { NumericFormat } from "react-number-format";
interface PriceFormatterProps {
  inputPrice: string | number;
  currency?: string;
  classNames?:string
}
const PriceFormatter: FC<PriceFormatterProps> = ({ inputPrice, currency,classNames }) => {
  return (
    <>
      <div className="!flex items-center gap-1">
        <NumericFormat
          className={`!text-[12px]  md:!text-[16px] !font-black ${classNames||"!text-black"}`}
          style={{ letterSpacing: -0.5 }}
          value={inputPrice}
          displayType="text"
          thousandSeparator="."
          decimalSeparator=","
          allowNegative={false}
          decimalScale={0}
          fixedDecimalScale
        />

        <span   className={`!text-[12px]  md:!text-[16px] !font-black ${classNames||"!text-black"}`}>
          {currency || "TL"}
        </span>
      </div>
    </>
  );
};

export default PriceFormatter;
